import { LoaderFunctionArgs, Outlet } from 'react-router';

import { SuperUserFragment } from '@/backoffice/types/types.generated';
import { TCustomRouteObject, THandle } from '@/shared/types/router.types';

export const userInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':userId/:tabId?',
    lazy: async () => {
      const { UserRoute } = await import('./user');
      return { Component: UserRoute };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { userLoader } = await import('./user');
      return userLoader(args);
    },
    handle: {
      crumb: {
        label: (data: SuperUserFragment) =>
          `${data.firstName} ${data.lastName}`,
      },
    },
  },
];

export const userRouteHandle: THandle = {
  crumb: {
    label: 'users',
    localized: true,
  },
  permission: { action: 'backofficeUser:readUser' },
};

export const userRoutes: TCustomRouteObject = {
  path: '/users',
  Component: () => <Outlet />,
  handle: userRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { UsersListRoute } = await import('./users');
        return { Component: UsersListRoute };
      },
    },
    ...userInnerRoutes,
  ],
};
